import { SET_ENVIRONMENT } from '../actions/environment';

const ENVIRONMENTS = {
  DEVELOPMENT: {
    name: 'Development',
    apiUrl: process.env.REACT_APP_DEVELOPMENT_API_URL || 'https://api-development.example.com',
  },
  STAGING: {
    name: 'Staging',
    apiUrl: process.env.REACT_APP_STAGING_API_URL || 'https://api-staging.example.com',
  },
  PRODUCTION: {
    name: 'Production',
    apiUrl: process.env.REACT_APP_PRODUCTION_API_URL || 'https://api.example.com',
  },
};

// Get initial environment from localStorage or default to STAGING
const getInitialEnvironment = () => {
  const savedEnv = localStorage.getItem('environment');
  return savedEnv && ENVIRONMENTS[savedEnv] ? savedEnv : 'STAGING';
};

const initialState = {
  currentEnvironment: getInitialEnvironment(),
  environments: ENVIRONMENTS,
};

const environmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ENVIRONMENT:
      if (ENVIRONMENTS[action.payload]) {
        localStorage.setItem('environment', action.payload);
        return {
          ...state,
          currentEnvironment: action.payload,
        };
      }
      return state;
    default:
      return state;
  }
};

export default environmentReducer; 